import { render, staticRenderFns } from "./sourceList.vue?vue&type=template&id=65faf2b2&scoped=true"
import script from "./sourceList.vue?vue&type=script&lang=js"
export * from "./sourceList.vue?vue&type=script&lang=js"
import style0 from "./sourceList.vue?vue&type=style&index=0&id=65faf2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65faf2b2",
  null
  
)

export default component.exports